import styled from "styled-components";

export const Label = styled.label`
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 13px;
  color: #666666;
`;
